import styled from '@emotion/styled';
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { Divider, LinearProgress } from '@mui/material'
import React from 'react'

import './HeaderStatistics.css'

function HeaderStatistics(props) {

  const points = props.points === undefined ? 0 : props.points
  
  let progress = points/props.goal * 100
  if (progress > 100)
  {
    progress = 100
  }
  if (props.goal === 0)
  {
    progress = 0
  }

  const BorderLinearProgress = styled(LinearProgress)(({}) => ({
    height: '100%',
    width: '100%',
    borderRadius: 20,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: 'var(--secondary-color)',
      boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.3) inset;"
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 20,
      backgroundColor: 'var(--primary-color)',
      boxShadow: "5px 0px 10px 0px rgba(0,0,0,0.3)"
    },
  }));


  return (
    <div className='header-statistics'>
      <div className='header-statistics-progress-bar'>
        <BorderLinearProgress variant="determinate" value={progress} />
        <div className='header-statistics-progress-bar-label'>
          {points + "/" + props.goal + " Total Points"}
        </div>
      </div>
    </div>
  )
}

export default HeaderStatistics